import { DateTime } from 'luxon'

/**
 * Los bordes de presentacion (§6 y §10).
 *
 * Todo lo que se guarda y se compara va en UTC. `America/Asuncion` aparece
 * solamente aca, al pintar. Si una zona horaria se filtra hacia adentro, las
 * citas empiezan a moverse solas cuando cambia el horario de verano.
 */

export const ZONA = 'America/Asuncion'
export const LOCALE = 'es-PY'

/** Guaranies: sin decimales, punto como separador de miles. `Gs. 150.000`. */
export function guaranies(monto: number): string {
  return `Gs. ${new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 0 }).format(Math.round(monto))}`
}

/** `14:30`. La hora local, que es la unica que le importa a quien mira la agenda. */
export function hora(iso: string): string {
  return DateTime.fromISO(iso, { zone: 'utc' }).setZone(ZONA).toFormat('HH:mm')
}

/** `mar 24 de feb`. */
export function fechaCorta(iso: string): string {
  return DateTime.fromISO(iso, { zone: 'utc' })
    .setZone(ZONA)
    .setLocale(LOCALE)
    .toFormat("ccc d 'de' LLL")
}

/** `martes 24 de febrero de 2026`. */
export function fechaLarga(iso: string): string {
  return DateTime.fromISO(iso, { zone: 'utc' })
    .setZone(ZONA)
    .setLocale(LOCALE)
    .toFormat("cccc d 'de' LLLL 'de' yyyy")
}

/** El dia local `2026-02-24` al que pertenece un instante UTC. */
export function diaLocal(iso: string): string {
  return DateTime.fromISO(iso, { zone: 'utc' }).setZone(ZONA).toISODate() ?? ''
}

/** Los limites UTC del dia local que se esta mirando. */
export function limitesDelDia(dia: string): { inicio: string; fin: string } {
  const arranque = DateTime.fromISO(dia, { zone: ZONA }).startOf('day')
  return {
    inicio: arranque.toUTC().toISO() ?? '',
    fin: arranque.plus({ days: 1 }).toUTC().toISO() ?? '',
  }
}

/** Minutos desde la medianoche local. Es la coordenada vertical del timeline. */
export function minutosDelDia(iso: string): number {
  const local = DateTime.fromISO(iso, { zone: 'utc' }).setZone(ZONA)
  return local.hour * 60 + local.minute
}

export function hoy(): string {
  return DateTime.now().setZone(ZONA).toISODate() ?? ''
}

export function sumarDias(dia: string, dias: number): string {
  return DateTime.fromISO(dia, { zone: ZONA }).plus({ days: dias }).toISODate() ?? ''
}
